import PropTypes from 'prop-types';
import OptionsList from '../../../../../Filters/OptionsList';

const RateCodeConfigPreferences = ({ onChange, preferences, selectedPreferences }) => {
  const handleChange = (itemValue, newValue) => {
    let newValues = [...selectedPreferences];
    if (newValue && !newValues.includes(itemValue)) {
      newValues.push(itemValue);
    } else if (!newValue) {
      newValues = newValues.filter((v) => v !== itemValue);
    }
    onChange(newValues);
  };

  return preferences.length === 0 ? (
    <></>
  ) : (
    <OptionsList
      options={preferences}
      selectedValues={selectedPreferences}
      onChange={handleChange}
    />
  );
};

RateCodeConfigPreferences.propTypes = {
  onChange: PropTypes.func.isRequired,
  preferences: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.object),
    PropTypes.arrayOf(PropTypes.any),
  ]),
  selectedPreferences: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.object),
    PropTypes.arrayOf(PropTypes.any),
  ]),
};

RateCodeConfigPreferences.defaultProps = {
  preferences: [],
  selectedPreferences: [],
};
export default RateCodeConfigPreferences;
